/**
 * Costanti dominio bolletta, copiate verbatim dal mobile:
 *   - enermed-app/src/screens/invoices/utils/costants.js (voci A-H)
 *   - enermed-app/src/utils/constants.js (colorsPie)
 */

export const VOCI_BOLLETTA: Record<string, string> = {
  A: 'Spesa per la materia energia',
  B: 'Spesa per il trasporto e gestione contatore',
  C: 'Spesa per oneri di sistema',
  D: 'Ricalcoli',
  E: 'Altre partite',
  F: 'Bonus sociale',
  G: 'Totale imposte e Iva',
  H: 'Canone di abbonamento televisione',
}

/** Colori delle fasce della donut, allineati al mobile. */
export const COLORS_PIE: Record<string, string> = {
  A: '#0263FF',
  B: '#FF7723',
  C: '#8E30FF',
  D: '#00A3DE',
  E: '#FFB703', // mobile aveva stringa vuota — fallback su giallo brand
  F: '#FF6FAA',
  G: '#2A9D8F',
  H: '#94A3B8',
}

export const EURO = '€'

/**
 * Mappa il `metodo_pagamento` del backend (Cognito + AppSync) sulla label
 * descrittiva mostrata nella sezione "Metodo di pagamento".
 * Replica `getMetodoPagamentoLabel` in InvoiceInfo.js.
 */
export function getMetodoPagamentoLabel(metodo: string | null | undefined): string {
  switch (metodo) {
    case 'Bollettino Postale':
      return 'Bollettino Postale (oppure paga ora con Stripe)'
    case 'Prepagata':
      return 'Prepagata - addebito automatico sul credito'
    case 'SDD':
      return 'SDD - addebito su conto corrente alla scadenza'
    case 'Sardex':
      return 'Sardex - 25% Sardex + 75% addebito CC'
    default:
      return 'Bonifico (oppure paga ora con Stripe)'
  }
}

/**
 * Vero/falso: la bolletta è pagabile via Stripe?
 *
 * Logica originale (InvoiceInfo.js:596):
 *   - SDD + scaduta → si paga (recupero)
 *   - non pagata + non SDD + non Prepagata → si paga
 *   - altrimenti no (es. SDD non scaduta, Prepagata, già pagata)
 */
export function checkCanPay(
  invoice: { stato?: string | null } | null,
  metodoPagamento: string | null | undefined,
): boolean {
  if (!invoice) return false
  const stato = (invoice.stato ?? '').toLowerCase()
  if (metodoPagamento === 'SDD' && stato === 'scaduta') return true
  if (stato !== 'pagata' && metodoPagamento !== 'SDD' && metodoPagamento !== 'Prepagata') {
    return true
  }
  return false
}
